export class AdvancedReorderConfig {
  applyToAll: boolean = false;
  ruleId: number;
  basedOnSelectedDays: number;
  basedOnHasCustom: boolean;
  basedOnSelectedMonths: number[][];
  orderForSelectedDays: number;
  orderForHasCustom: boolean;
  orderForSelectedMonths: number[][];
  adjustment: number;
  manualEntry: number;
  minusAllInventory: boolean;
  minusAllStoresInventory: boolean;
  minusAllStoresOverstockedInventory: boolean;
  minusLocations: any[] = [];
  minusStores: any[] = [];
  minusOverstockedStores: any[] = [];
  minusPOs: boolean;
  outOfStock: boolean;
  buyBox: boolean;
}